module.exports = __webpack_public_path__ + "static/media/logo-sibelga.6228c316.svg";